<template>
  <div class="vl-common-app">
    <iframe
      :src="appCenterUrl"
      allow="camera; geolocation; microphone"
      allowtransparency="true"
      id="appCenterIframe"
      name="appCenterIfr"
      allowpaymentrequest="true"
      allowfullscreen="true"
      frameborder="0"
      :style="{height: iframeHeight + 'px'}"
      class="app-content">
    </iframe>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        appCenterUrl: '',
        iframeHeight: 1000
      }
    },
    mounted() {
      this.appCenterUrl = window.ENV_API.WORK_URL + 'portalUi/isIframe';
      let ifr = document.getElementById("appCenterIframe");
      let ifrw = (ifr.contentWindow) ? ifr.contentWindow: (ifr.contentDocument) ? ifr.contentDocument.document: ifr.contentDocument;
      if (ifrw.document.getElementById('vlAppCenter')) {
        this.iframeHeight = ifrw.document.getElementById('vlAppCenter').clientHeight + 20;
      }
      window.addEventListener('message', () => {
        this.iframeHeight = ifrw.document.getElementById('vlAppCenter').clientHeight + 20;
      }, false);
    },
    methods: {},
  }
</script>
<style lang="scss" scoped>
  .vl-common-app {
    width: 100%;
    height: 100%;
    .app-content {
      width: 100%;
      min-height: 850px;
    }
  }
</style>